import {
  Redirect,
  Route,
  Switch,
  useHistory,
  useRouteMatch
} from "react-router-dom";
import { FormCreateInternalAccount } from "../../components/FormCreateInternalAccount";
import { ReviewTaxWithholdingsRate } from "./components/ReviewTaxWithholdingsRate";
import { FlowStep } from "../../../../shared/components/FlowSwitch/types";

export const ConfirmAndSave: React.FC<FlowStep> = props => {
  const history = useHistory();
  const match = useRouteMatch();
  const basePath = match.path;

  return (
    <Switch>
      <Route path={basePath + "/review"}>
        <ReviewTaxWithholdingsRate
          onBack={props.onBack}
          onNext={value => {
            if (value === "activate") {
              history.push(basePath + "/activate");
            } else if (value === "skip") {
              props.onSkip?.();
            } else {
              props.onNext?.();
            }
          }}
        />
      </Route>

      <Route path={basePath + "/activate"}>
        <FormCreateInternalAccount
          type="TaxWithholding"
          currency="USD"
          onBack={() => {
            history.push(basePath + "/review");
          }}
          onContinue={props.onNext}
        />
      </Route>

      <Redirect from={basePath} to={basePath + "/review"} />
    </Switch>
  );
};
